import { render, staticRenderFns } from "./GalaxyMars.vue?vue&type=template&id=3b434292&scoped=true"
import script from "./GalaxyMars.vue?vue&type=script&lang=js"
export * from "./GalaxyMars.vue?vue&type=script&lang=js"
import style0 from "./GalaxyMars.vue?vue&type=style&index=0&id=3b434292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b434292",
  null
  
)

export default component.exports